import { CommonResponse } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Repository } from 'typeorm';
// import { fgStockTransferReq } from './fg-stock-transfer';
import { fgStockTransferReq } from 'apps/services/warehouse-service/src/app/fg-stock-transfer/fg-stock-transfer-request';

import { fgStockTransfer } from './fg-stock-transfer.entity';
import appSettings from 'apps/services/config';
import { Cron } from '@nestjs/schedule';
import { GlobalVariableValues, MessageParameters, TransferStatusEnum } from '@gtpl/shared-models/common-models';
import { time } from 'cron';
import whatsApp from 'apps/services/whatsapp';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import moment from 'moment';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
@Injectable()
export class FgStockTransferService {
    constructor(
      @InjectRepository(fgStockTransfer)
       private repository:  Repository<fgStockTransfer>,
      private wpService: WhatsAppNotificationService,
      private wtsAppBroadCatService : WhatsappBroadCastService,


      ) {
    }
    
    async gettransferTypeData(req?:fgStockTransferReq):Promise<CommonResponse> {
        try{
            const manager = getManager();
            let query = 'SELECT uc.unit_name AS oldUnitName,sl.cartons,st.sale_order_id,soi.po_number,s.variant_code,sl.purpose,uco.unit_name AS newUnitName,upsoi.variant_code AS updateSoItem,rp.rack_code AS oldRackCode, sid.po_number AS updatedPonumber,sk.variant_code AS variantCode,sd.po_number AS oldPoNumber,stock_log_id AS stockLogId,sl.stock_id AS stockId, old_rack_position_id AS oldRackPositionId,updated_rack_position_id AS updatedRackPositionId,old_plant_id AS oldPlantId,rpo.rack_code AS newRackCode,updated_plant_id AS updatedPlantId,old_so_id AS oldSoId,updated_so_id AS updatedSoId,old_so_item_id AS oldSoItemId,updated_so_item_id AS updatedSoItemId,sl.created_at AS createdAt FROM `erpx_dev_warehouse`.`stock_log` sl LEFT JOIN `erpx_dev_sales`.`so_invoice_details` sd ON sl.old_so_id=sd.sale_order_id LEFT JOIN `erpx_dev_sales`.`so_invoice_details` sid ON sl.updated_so_id=sid.sale_order_id  LEFT JOIN `erpx_dev_masters`.`sku_codes` sk ON sk.sku_code_id=sl.old_so_item_id LEFT JOIN `erpx_dev_masters`.`rack_position` rp ON rp.rack_position_id=sl.old_rack_position_id LEFT JOIN `erpx_dev_masters`.`rack_position` rpo ON rpo.rack_position_id=sl.updated_rack_position_id LEFT JOIN `erpx_dev_masters`.`sku_codes` upsoi ON sl.updated_so_item_id=upsoi.sku_code_id LEFT JOIN `erpx_dev_masters`.`unitcodes` uc ON uc.unit_code_id=sl.old_plant_id LEFT JOIN `erpx_dev_masters`.`unitcodes` uco ON uco.unit_code_id=sl.updated_plant_id LEFT JOIN `erpx_dev_warehouse`.`stock` st ON st.stock_id = sl.stock_id LEFT JOIN `erpx_dev_sales`.`so_invoice_details` soi ON soi.sale_order_id = st.sale_order_id LEFT JOIN `erpx_dev_masters`.`sku_codes` s ON st.varient_id = s.sku_code_id WHERE stock_log_id>0'
            if (req.unitId && req.unitId != 5) {
              query = query + ' and sl.plant_id = ' + req.unitId;
              if(req.transferType){
                query=query+' AND sl.purpose = "'+req.transferType+'"'
              }
              if(req.Date){
                  query=query+' And DATE(sl.created_at) = "'+req.Date+'"';
              }
            }
            else{
                if(req.transferType){
                  query=query+' AND sl.purpose = "'+req.transferType+'"'
                }
                if(req.Date){
                    query=query+' And DATE(sl.created_at) = "'+req.Date+'"';
                } 
              
            }
             
            const result = await manager.query(query)
            if (result) { 
                return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
              } else {
                return new CommonResponse(false, 1111, "Error occure")
        
              }
        }
        catch (err) {
            return err;
          }
    }

    // async getAlertData(){
    //   try{
    //   // const manager = getManager();
    //   // let trasferUrl = appSettings.whatsapp_redirection_url + '/fg_warehouse_stock_transfer_report';
    
    //   }
    // }
  @Cron('0 8 * * *')
  async getFgWarehouseTransferStatus():Promise<CommonResponse> {
      try{
        const manager = getManager();
        let dataArry :string[]= []
      let fgStockTransfer = appSettings.whatsapp_redirection_url + '/fg-stock-transfer-report';
      // let allvalues = Object.values(TransferStatusEnum)
      // for (const [index, allvaluesItem] of allvalues.entries()) {
       const query = ' SELECT purpose,SUM(IF(plant_id=1,1,0)) AS kakinada,SUM(IF(plant_id=2,1,0)) AS unitone,SUM(IF(plant_id=3,1,0)) AS unittwo FROM `erpx_dev_warehouse`.`stock_log` sl LEFT JOIN `erpx_dev_masters`.`unitcodes` u ON u.unit_code_id =sl.plant_id WHERE purpose IS NOT NULL  GROUP BY purpose'
      // }
      const result = await manager.query(query)
      const time = moment().format('MMMM Do, YYYY');
      let value = '';
      if(result.length >0){
        for(const res of result){
        value += "\n\nTransferType : " + res.purpose+'\n'+ 
        "\nKakinada : " + res.kakinada+'\n'+ 
        "\nUnitOne : " + res.unitone+'\n'+
         "\nUnitTwo : " + res.unittwo+'\n'
     }    
        dataArry.push(value)
        // console.log('@--------------@',dataArry)
        // console.log(value,'##')

      }
      else{

      }
      
      const parameters = [
        { "type": "text", "text": time},
        { "type": "text", "text": value},
        {"type":"text","text":fgStockTransfer},
      ];
      console.log('__________________',parameters)
      const contacts = whatsApp.contacts;
      let statusFlag 
      for(const contact of contacts){
          const req = await new MessageParameters(contact, 'fg_warehouse_stock_transfer_report', parameters,'en_us')
          const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
          console.log('messageStatus',messageStatus)
          if(!messageStatus.status){
              statusFlag = false
          }
          else{
            statusFlag = true
            const whatsapplogDto = new WhatsAppLogDto(contact,'fg_warehouse_stock_transfer_report','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.warehouseModuleId)
            await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
          }
      }    
  }
  catch(err){
    return err
  }
  }
   

 
}
